import api from './api';
import {
  Aufgabe,
  AufgabeKommentar,
  AufgabeStatus,
  CreateAufgabeRequest,
  UpdateAufgabeRequest,
  CreateAufgabeStatusRequest,
  UpdateAufgabeStatusRequest,
  User,
} from '../types';

const aufgabeService = {
  getAll: async (): Promise<Aufgabe[]> => {
    const response = await api.get('/aufgaben');
    return response.data;
  },

  getById: async (id: number): Promise<Aufgabe> => {
    const response = await api.get(`/aufgaben/${id}`);
    return response.data;
  },

  create: async (data: CreateAufgabeRequest): Promise<Aufgabe> => {
    const response = await api.post('/aufgaben', data);
    return response.data;
  },

  update: async (id: number, data: UpdateAufgabeRequest): Promise<Aufgabe> => {
    const response = await api.put(`/aufgaben/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/aufgaben/${id}`);
  },

  getAllStatus: async (): Promise<AufgabeStatus[]> => {
    const response = await api.get('/aufgaben/status');
    return response.data;
  },

  createStatus: async (data: CreateAufgabeStatusRequest): Promise<AufgabeStatus> => {
    const response = await api.post('/aufgaben/status', data);
    return response.data;
  },

  updateStatus: async (id: number, data: UpdateAufgabeStatusRequest): Promise<void> => {
    await api.put(`/aufgaben/status/${id}`, data);
  },

  deleteStatus: async (id: number): Promise<void> => {
    await api.delete(`/aufgaben/status/${id}`);
  },

  getBenutzer: async (): Promise<User[]> => {
    const response = await api.get('/aufgaben/benutzer');
    return response.data;
  },

  addKommentar: async (aufgabeId: number, text: string): Promise<AufgabeKommentar> => {
    const response = await api.post(`/aufgaben/${aufgabeId}/kommentare`, { text });
    return response.data;
  },

  deleteKommentar: async (kommentarId: number): Promise<void> => {
    await api.delete(`/aufgaben/kommentare/${kommentarId}`);
  },
};

export default aufgabeService;
